import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { DATE_TIME_ZONE_LABEL, formatDateTime } from '../utils/format.utils';

interface DateTimeTextProps {
  value: string;
}

// A timestamp in Jujuy's time, with the timezone on hover
export const DateTimeText: React.FC<DateTimeTextProps> = ({ value }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span className="cursor-help underline decoration-dotted underline-offset-2">
        {formatDateTime(value)}
      </span>
    </TooltipTrigger>
    <TooltipContent>{DATE_TIME_ZONE_LABEL}</TooltipContent>
  </Tooltip>
);
